<template>
    <div class="timeout-layout" style="font-family: Arial, sans-serif;">
        <!-- Header block: logo + card stacked -->
        <div class="header-block">
            <img
                class="main-logo"
                :src="require('@/assets/main_logo.png')"
                alt="Main logo"
            >
            <v-card color="#4900c3" class="" style="min-width: 350px;">
                <div class="custom-teal-text font-weight-bold py-6 px-10">
                    {{ getMatchTitle() }}
                </div>
            </v-card>
            <v-card color="#4900c3" class="" style="min-width: 500px;">
                <div class="white--text font-weight-bold py-6 px-10">
                    {{ (match.round > 0 ? ('Matchday ' + match.round + ', ') : '') + (match.cup ? 'Κύπελλο' : (match.phase === 'regular_season' ? 'Regular Season' : (match.phase === 'playoffs' ? 'Play Offs' : 'Friendly Match'))) }}
                </div>
            </v-card>
        </div>

        <div class="timeout-side-left" />
        <div class="timeout-center">
            <div class="center-card font-weight-bold">
                <v-card color="#4900c3" class=" px-10 py-5 white--text" min-width="1000px" :style="`box-shadow: inset 30px 0 0 0 ${match.team1.color};`">
                    <!-- changed: wrap in flex row -->
                    <div class="media-row">
                        <v-avatar style="border-radius: 10px;" size="150px" color="white">
                            <img :src="`${assetsUrl}/${match.team1?.logo}`" height="150px" width="auto">
                        </v-avatar>
                        <span class="" style="width: 300px;">{{ match.team1.name }}</span>
                        <span
                            v-for="period in periods"
                            :key="`team1-period-${period}`"
                            class="pl-10"
                            style="font-size: 55px; font-weight: bold; width: 110px;"
                            :style="{
                                fontWeight: 'bold',
                                color: ((Number(periodScoresTeam1[period]) || 0) > (Number(periodScoresTeam2[period]) || 0)) ? '#e3f905' : ''
                            }"
                        >
                            {{ periodScoresTeam1[period] ?? '-' }}
                        </span>
                        <span
                            class="pl-10"
                            style="font-size: 75px; font-weight: bold; margin-left: auto; width: 200px;"
                            :class="(Number(match.team1Score) || 0) > (Number(match.team2Score) || 0) ? 'custom-teal-text' : 'white--text'"
                        >
                            {{ match.team1Score }}
                        </span>
                    </div>
                </v-card>
                <v-card color="#4900c3" class=" my-5 px-10 py-5 white--text" min-width="1000px" :style="`box-shadow: inset 30px 0 0 0 ${match.team2.color};`">
                    <!-- changed: wrap in flex row -->
                    <div class="media-row">
                        <v-avatar style="border-radius: 10px;" size="150px" color="white">
                            <img :src="`${assetsUrl}/${match.team2?.logo}`" height="150px" width="auto">
                        </v-avatar>
                        <span class="" style="width: 300px;">{{ match.team2.name }}</span>
                        <span
                            v-for="period in periods"
                            :key="`team2-period-${period}`"
                            class="pl-10"
                            style="font-size: 55px; font-weight: bold; width: 110px;"
                            :style="{
                                fontWeight: 'bold',
                                color: ((Number(periodScoresTeam2[period]) || 0) > (Number(periodScoresTeam1[period]) || 0)) ? '#e3f905' : ''
                            }"
                        >
                            {{ periodScoresTeam2[period] ?? '-' }}
                        </span>
                        <span
                            class="pl-10"
                            style="font-size: 75px; font-weight: bold; margin-left: auto; width: 200px;"
                            :class="(Number(match.team2Score) || 0) > (Number(match.team1Score) || 0) ? 'custom-teal-text' : 'white--text'"
                        >
                            {{ match.team2Score }}
                        </span>
                    </div>
                </v-card>
            </div>
        </div>
        <div class="timeout-side-right" />
    </div>
</template>

<script>
    import matchService from '@/services/match'
    export default {
        name: 'TimeOut',
        data() {
            return {
                match: {},
                assetsUrl: 'https://storage.googleapis.com',
                periodScoresTeam1: {},
                periodScoresTeam2: {},
                periods: []
            }
        },
        mounted() {
            const matchId = this.$route.params.id
            this.fetchMatch(matchId)
        },
        methods: {
            getMatchTitle() {
                if (this.match.cupLeague) {
                    return this.match.cupLeague.title
                } else if (this.match.league) {
                    return this.match.league.title
                } else {
                    return 'Τελικός'
                }
            },
            // return computed period points without padding
            getPeriodPoints(team) {
                if (!team || !team.players) return {}
                const periodPoints = {}
                team.players.forEach(player => {
                    const ps = player?.stats?.[0]?.periodScore
                    if (ps) {
                        Object.entries(ps).forEach(([period, points]) => {
                            periodPoints[period] = (periodPoints[period] || 0) + points
                        })
                    }
                })
                return periodPoints
            },

            // keep only the keys from the object with fewer numeric (>0) keys
            alignPeriodScores(t1, t2) {
                const norm = (obj) =>
                    Object.keys(obj || {})
                        .map(k => Number(k))
                        .filter(n => Number.isFinite(n) && n > 0)
                        .sort((a, b) => a - b)

                const k1 = norm(t1)
                const k2 = norm(t2)

                const baseKeys = (k1.length && k1.length <= k2.length) ? k1 : k2.length ? k2 : []
                const build = (obj, keys) => keys.reduce((acc, k) => {
                    const v = obj[String(k)]
                    acc[k] = (v === undefined || v === null) ? '-' : v
                    return acc
                }, {})

                return {
                    team1: build(t1, baseKeys),
                    team2: build(t2, baseKeys),
                    keys: baseKeys
                }
            },

            fetchMatch(matchId) {
                return matchService.getMatch(matchId).then(resp => {
                    this.match = resp.data
                    const t1 = this.getPeriodPoints(resp.data.team1)
                    const t2 = this.getPeriodPoints(resp.data.team2)
                    const aligned = this.alignPeriodScores(t1, t2)
                    this.periodScoresTeam1 = aligned.team1
                    this.periodScoresTeam2 = aligned.team2
                    this.periods = aligned.keys
                })
            }
        }
    }
</script>

<style scoped>
.timeout-layout {
    display: flex;
    min-height: 100vh;
    position: relative; /* anchor absolute header */
    overflow: visible;

    /* 1.8x bigger */
    --cell-size: clamp(50px, 9vw, 86px);
    --font-size: clamp(21.6px, 3.24vw, 32.4px);
    --label-font-size: clamp(18px, 2.88vw, 28.8px);
    --gap: clamp(14px, 2.7vw, 36px);

    font-size: var(--font-size) !important;
}

/* Absolute container for logo + card */
.header-block {
    position: absolute;
    top: 12px;
    left: 105px;
    z-index: 5;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}

/* Logo uses natural flow inside header-block */
.main-logo {
    width: clamp(160px, 24vw, 280px); /* 2x bigger */
    height: auto;
    pointer-events: none;
}

/* Sides and center stay as-is */
.timeout-side-left {
    flex: 0 0 20%;
    max-width: 20%;
    background-color: #140542;
    opacity: 0.6;
    z-index: 1;
}

.timeout-side-right {
    flex: 0 0 25%;
    max-width: 25%;
    background-color: #140542;
    opacity: 0.6;
    z-index: 1;
}

.timeout-center {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex: 1 1 auto;
    padding: 16px;
    position: relative;
    z-index: 2;
    overflow: visible;
}

.center-card {
    display: inline-block;
    position: relative;
    z-index: 3;
    margin-top: 58vh;
    transform: translateX(36%);
}

@media (max-width: 960px) {
    .center-card {
        margin-top: 42vh;
        transform: translateX(3%);
    }
}

.center-card ::v-deep .v-card {
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.media-row {
    display: flex;
    align-items: center;        /* vertical center */
    justify-content: flex-start;/* horizontal start (left) */
    gap: 12px;                  /* space between image and text */
}
</style>
